const routes = [

    {
        // =============================================================================
        // MAIN LAYOUT ROUTES
        // =============================================================================
        path: '',
        component: () => import('../layouts/main/Main.vue'),
        children: [
            // =============================================================================
            // Theme Routes
            // =============================================================================
            {
                path: '/admin/dashboard',
                name: 'Dashboard',
                component: () => import('../views/admin/events/NextEventListing'),
                meta: {
									roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/event/new',
                name: 'New Event',
                component: () => import('../views/admin/events/NextEvent'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/past',
                name: 'Past Event',
                component: () => import('../views/admin/events/PastEventListing'),
                meta: {
									roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/event/invite/:id',
                name: 'Invite',
                component: () => import('../views/admin/events/Invite'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/run/:id',
                name: 'Run Event',
                component: () => import('../views/admin/events/RunEvent'),
                meta: {
					roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/event/users/:id',
                name: 'Event Users',
                component: () => import('../views/admin/events/EventUsers'),
                meta: {
									roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/settings',
                name: 'Admin Settings',
                component: () => import('../views/admin/Settings'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/edit/:id',
                name: 'Event Edit',
                component: () => import('../views/admin/events/EventEdit'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/user/list',
                name: 'User List',
                component: () => import('../views/admin/users/Listing'),
                meta: {
									roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/quorum/list',
                name: 'Quorum List',
                component: () => import('../views/admin/quorum/QuorumListing'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/globalsettings',
                name: 'Settings',
                component: () => import('../views/admin/events/GlobalSettings'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/editsettings/:id',
                name: 'Edit Settings',
                component: () => import('../views/admin/events/EditSettings'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/users/viewhistory/:id',
                // trick to fix url issue everywhere :)
                redirect: r => ({name: 'ViewUser', params: {id: r.params.id}}),
                name: 'View User Event History',
                meta: {
				    roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/user/create',
                name: 'CreateUser',
                component: () => import('../views/admin/users/CreateUpdate'),
                meta: {
				    roles: ['admin']
                },
            },
            {
                path: '/admin/user/:id/edit',
                name: 'EditUser',
                component: () => import('../views/admin/users/CreateUpdate'),
                meta: {
				    roles: ['admin']
                },
            },
            {
                path: '/admin/user/:id',
                name: 'ViewUser',
                component: () => import('../views/admin/users/View'),
                meta: {
				    roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/event/user/:id/upcoming-events',
                name: 'UserUpcomingEvents',
                component: () => import('../views/admin/users/UpcomingEvents'),
                meta: {
					roles: ['admin']
                },
            },
            {
                path: '/admin/event/agenda/:id',
                name: 'Manage Agenda',
                component: () => import('../views/admin/agenda/ManageAgenda'),
                meta: {
                  roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/event/notifications/:id',
                name: 'Set Notifications',
                component: () => import('../views/admin/events/SetNotifications'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/smsemailnotifications/:id',
                name: 'Sms Email Notifications',
                component: () => import('../views/admin/events/Notifications'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/editnotification/:id/:slug',
                name: 'Edit Notifications',
                component: () => import('../views/admin/events/EditTemplate'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/editnotification/:id/:slug/:from',
                name: 'Edit Notifications',
                component: () => import('../views/admin/events/EditTemplate'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/event/customnotifications/:id',
                name: 'Manage Notifications',
                component: () => import('../views/admin/settings/CustomNotifications'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/settings/design/:id',
                name: 'Design Settings',
                component: () => import('../views/admin/settings/DesignSettings'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/designsettings',
                name: 'Design Settings',
                component: () => import('../views/admin/settings/GlobalDesignSettings'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/profile',
                name: 'Profile',
                component: () => import('../views/admin/settings/ChangePassword'),
                meta: {
									roles: ['admin','admin_observer']
                },
            },
            {
                path: '/admin/event/pasteventdetails/:id',
                name: 'Run Event',
                component: () => import('../views/admin/events/RunEvent'),
                meta: {
                    roles: ['admin','admin_observer'],
                    pastEvent: true
                },
            },
            {
                path: '/admin/event/recordings/:id',
                name: 'Event Recordings',
                component: () => import('../views/admin/events/Recordings'),
                meta: {
                    roles: ['admin','admin_observer'],
                    pastEvent: true
                },
            },
            {
                path: '/admin/create',
                name: 'Create Admin',
                component: () => import('../views/admin/users/CreateAdminUser'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/privacy-policy',
                name: 'Privacy Policy',
                component: () => import('../views/admin/PrivacyPolicy'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/language',
                name: 'Languages',
                component: () => import('../views/admin/languages/List'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/language/:code/edit',
                name: 'LanguageEdit',
                component: () => import('../views/admin/languages/Edit'),
                meta: {
                    roles: ['admin']
                },
            },
            {
                path: '/admin/tracking-logs',
                name: 'TrackLogs',
                component: () => import('../views/admin/TrackLogs'),
                meta: {
                    roles: ['admin']
                }
            },
            {
              path: '/admin/campaign',
              name: 'CampaignList',
              component: () => import('../views/admin/campaign/index'),
              meta: {
                  roles: ['admin']
              }
            },
            {
              path: '/admin/campaign/create',
              name: 'CampaignCreate',
              component: () => import('../views/admin/campaign/create'),
              meta: { roles: ['admin'] }
            },
            {
              path: '/admin/campaign/view/:id',
              name: 'CampaignView',
              component: () => import('../views/admin/campaign/view'),
              meta: { roles: ['admin'] }
            },
            {
              path: '/admin/campaign/:id/message/:message_id/preview',
              name: 'CampaignMessagePreview',
              component: () => import('../views/admin/campaign/mail-preview'),
              meta: {
                  roles: ['admin']
              }
            },
        ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: [
            // =============================================================================
            // PAGES
            // =============================================================================
            {
                path: '/admin/login',
                name: 'page-login',
                component: () => import('@/views/admin/auth/Login.vue')
            },
            {
                path: '/admin/forgot-password',
                name: 'page-forgot-password',
                component: () => import('@/views/pages/ForgotPassword.vue')
            },
            {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
            },
            {
                path: '/admin/reset-password/:token',
                name: 'reset-password',
                component: () => import('@/views/pages/ResetPassword.vue')
            },
        ]
    },
    // Redirect to 404 page, if no match found
    {
        path: '*',
        redirect: '/pages/error-404'
    }
];

export default routes